import { useHistory } from 'react-router-dom';
import { IPartner, ThemeStatus } from 'types/Partner';
import { maskCNPJ, maskDate } from 'util/masks';

import SearchIcon from '@mui/icons-material/Search';
import {
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { styled } from '@mui/styles';
import { useMemo } from 'react';

const StyledTableCell = styled(TableCell)(() => ({
  color: '#4B4B4B',
}));

export interface IConvertedPartnerRow {
  convertedPartner: IPartner | undefined;
}

export const ConvertedPartnersRow: React.FC<IConvertedPartnerRow> = ({
  convertedPartner,
}) => {
  const { push } = useHistory();

  const { company, createdAt, cnpj, status, active } = convertedPartner ?? {};

  //@ts-ignore
  const themeStatus = ThemeStatus[status];

  const { color, title } = useMemo(() => {
    if (!active || (status === 'pending' && !company)) {
      return { color: '#d9bf16', title: 'Pré-cadastro' };
    }

    return themeStatus;
  }, [active, status, company, themeStatus]);

  const handleViewConvertedPartner = () => {
    if (!convertedPartner?._id) {
      return;
    }
    push(`/admin/dashboard/partners/view/${convertedPartner?._id}`);
  };

  if (!convertedPartner?._id) {
    return null;
  }

  return (
    <>
      <TableRow>
        <StyledTableCell>{maskDate(createdAt || '')}</StyledTableCell>

        <StyledTableCell>{company ?? '-'}</StyledTableCell>

        <StyledTableCell>{cnpj ? maskCNPJ(cnpj) : '-'}</StyledTableCell>

        <TableCell>
          <Typography color={color ?? '#000'}>{title}</Typography>
        </TableCell>

        <TableCell align="right">
          <Stack flexDirection="row" gap="8px" justifyContent="flex-end">
            <Tooltip title="Ver mais">
              <IconButton
                aria-label="info"
                color="inherit"
                onClick={handleViewConvertedPartner}
              >
                <SearchIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </TableRow>
    </>
  );
};
